import React from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import styles from './CustomFieldsForm.module.css'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { DatePickerFormFieldInline } from 'components/Shared/DatePickerInline'
import { DateTimePickerField } from 'components/Shared/DateTimePickerField'
import CustomFieldType from 'constants/CustomFieldTypes'
import LabeledCheckboxField from 'components/Shared/LabeledCheckboxField/LabeledCheckboxField'
import SelectOptionsFieldArray from 'components/CustomFields/CustomFieldsForm/SelectOptionsFieldArray'

export default function FieldDetails () {
  const { values } = useFormikContext()
  const { t } = useTranslation()

  return (() => {
    switch (values.type) {
      case CustomFieldType.Boolean:
        return <div className={styles.fieldDetailsOffset}>
          <LabeledCheckboxField
            fieldName="defaultValue.bool"
            label="customField.form.defaultValue"
          />
        </div>
      case CustomFieldType.Date:
        return <div className={styles.fieldDetailsOffset}>
          <DatePickerFormFieldInline
            name={'defaultValue.date'}
            label={'customField.form.defaultValue'}
            inputClassName={styles.dateField}
            clearable/>
        </div>
      case CustomFieldType.DateTime:
        return <div className={styles.fieldDetailsOffset}>
          <DateTimePickerField
            label={t('customField.form.defaultValue')}
            placeholder={t('customField.form.defaultValue')}
            fieldName={'defaultValue.dateTime'}
            disableClear={false}/>
        </div>
      case CustomFieldType.Text:
        return <div className={styles.fieldDetailsOffset}>
          <FieldComponent
            fieldName='defaultValue.text'
            label='customField.form.defaultValue'
          />
          <FieldComponent
            type='number'
            fieldName='maxCharCount'
            label='customField.form.maxCharCount'
          />
        </div>
      case CustomFieldType.Select:
        return <SelectOptionsFieldArray/>
      default:
        return <></>
    }
  })()
}
